import React from 'react'
import { Icon, HeadingText, Row } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'

/* 
 Reference - https://github.com/bvaughn/react-error-boundary#readme
  https://kentcdodds.com/blog/use-react-error-boundary-to-handle-errors-in-react  
    
    ErrorFallback component for 'react-error-boundary' module to handle the errors
*/

function ErrorFallback() {
  return (
    <div>
      <Row>
        <Icon name="critical" size="xl" color="sysColorErrorMain" />
        <HeadingText 
          level={2} 
          style={{ color: '#ff9100' }}
          data-testid="hc-error-fallback-header"
        >
          <Message id="app.helpcenter.error.label" />
        </HeadingText>
      </Row>
    </div>
  )
}

export default ErrorFallback
